// extracted by mini-css-extract-plugin
export var button = "_6m-4";
export var hasDarkBackground = "_6m-7";
export var hasLightBackground = "_6m-6";
export var iconWrapper = "_6m-0";
export var large = "_6m-2";
export var medium = "_6m-1";
export var small = "_6m-5";
export var xsmall = "_6m-3";